import { Component, OnInit } from '@angular/core';
import { TableColumn } from '../../../../dto/util/table-column';
import { DefinicionDTO } from '../models/definicionDTO';

@Component({
  selector: 'app-tabla-definiciones',
  templateUrl: './tabla-definiciones.component.html',
  styleUrl: './tabla-definiciones.component.scss',
})
export class TablaDefinicionesComponent implements OnInit {
  // Datos de la tabla
  columnas!: TableColumn[];
  datos: DefinicionDTO[] = [];
  ngOnInit(): void {
    // Definición de las columnas
    this.columnas = [
      {
        field: 'tipoDemanda',
        title: 'Tipo demanda',
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'definicion',
        title: 'Definición',
        type: 'html',
        filterable: false,
        sortable: false,
      },
    ];
    // Definiciones según tipo demanda
    this.datos = [
      {
        tipoDemanda:
          'Cobertura de servicios \n' +
          'incluidos en el Plan de \n' +
          'Beneficios en Salud- PBS',
        definicion:
          'Si su Entidad Promotora de Salud- EPS o entidad que se le asimile le niega los \n' +
          'servicios, tecnologías en salud o procedimientos incluidos en el Plan de \n' +
          'Beneficios- PBS.',
      },
      {
        tipoDemanda: 'Conflictos por libre elección y \n' + 'movilidad\n',
        definicion:
          'Si le niegan la libre elección para afiliarse a la EPS de su interés, o le impiden \n' +
          'elegir las Instituciones Prestadoras de Servicios de Salud- IPS dentro de la red \n' +
          'conformada por su EPS, o tiene conflictos relacionados con la movilidad dentro \n' +
          'del SGSSS.\n',
      },
      {
        tipoDemanda:
          'Conflictos por multiafiliación \n' +
          'dentro del Sistema General de \n' +
          'Seguridad Social en Salud-SGSSS',
        definicion:
          'Si usted aparece afiliado en varias EPS o en varios regímenes en el SGSSS, \n' +
          'de manera simultánea.\n',
      },
      {
        tipoDemanda: 'Reconocimiento económico de \n' + 'gastos en Salud',
        definicion:
          '<p>Si usted, como usuario o afiliado del SGSSS incurre en algún gasto:</p>\n' +
          '<div class="text-start"> <ul>\n' +
          '    <li>Por la atención de un servicio de urgencia.</li>\n' +
          '    <li>Por la atención específica que le haya sido autorizada por la EPS o las entidades que se le asimilen.</li>\n' +
          '    <li>Por la imposibilidad, negativa injustificada o negligencia demostrada de la EPS o entidades que se le asimilen.</li>\n' +
          '</ul></div>',
      },
      {
        tipoDemanda:
          'Conflictos derivados de las \n' +
          'devoluciones o glosas a las \n' +
          'facturas, reclamaciones y \n' +
          'recobros de servicios No PBS',
        definicion:
          'Si como entidad o institución del SGSSS presenta conflictos derivados de las \n' +
          'devoluciones o glosas a las facturas por servicios de salud, recobros por \n' +
          'servicios no incluidos en el PBS y reclamaciones ante la ADRES.',
      },
      {
        tipoDemanda:
          'Prestaciones no incluidas en el \n' +
          'Plan de Beneficios en Salud -\n' +
          'PBS\n',
        definicion:
          'Si tiene un conflicto con su EPS o entidad que se le asimile, por la garantía de \n' +
          'la prestación de los servicios y tecnologías NO incluidas en el PBS, con \n' +
          'excepción de aquellos expresamente excluidos de la financiación con recursos \n' +
          'públicos asignados a la salud.',
      },
    ];
  }
}
